let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jQLsm")).then(() => parcelRequire('kpPKM'));